import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Tenants from "@/pages/Tenants";
import Users from "@/pages/Users";
import Categories from "@/pages/Categories";
import Currencies from "@/pages/Currencies";
import Settings from "@/pages/Settings";
import Claims from "@/pages/Claims";
import NewClaim from "@/pages/NewClaim";
import ClaimDetail from "@/pages/ClaimDetail";
import Reports from "@/pages/Reports";

const withLayout = (el) => <ProtectedRoute><AppLayout>{el}</AppLayout></ProtectedRoute>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Navigate to="/login" replace />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/dashboard" element={withLayout(<Dashboard />)} />
      <Route path="/tenants" element={<ProtectedRoute roles={["super_admin"]}><AppLayout><Tenants /></AppLayout></ProtectedRoute>} />
      <Route path="/users" element={<ProtectedRoute roles={["super_admin", "admin", "manager", "branch_manager"]}><AppLayout><Users /></AppLayout></ProtectedRoute>} />
      <Route path="/categories" element={<ProtectedRoute roles={["super_admin", "admin", "manager", "branch_manager"]}><AppLayout><Categories /></AppLayout></ProtectedRoute>} />
      <Route path="/currencies" element={<ProtectedRoute roles={["super_admin"]}><AppLayout><Currencies /></AppLayout></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute roles={["super_admin", "admin", "manager", "branch_manager"]}><AppLayout><Settings /></AppLayout></ProtectedRoute>} />
      <Route path="/claims" element={<ProtectedRoute roles={["admin", "manager", "employee", "branch_manager"]}><AppLayout><Claims /></AppLayout></ProtectedRoute>} />
      <Route path="/claims/new" element={<ProtectedRoute roles={["employee", "manager", "admin", "branch_manager"]}><AppLayout><NewClaim /></AppLayout></ProtectedRoute>} />
      <Route path="/claims/:id/edit" element={<ProtectedRoute roles={["employee", "manager", "admin", "super_admin", "branch_manager"]}><AppLayout><NewClaim /></AppLayout></ProtectedRoute>} />
      <Route path="/claims/:id" element={withLayout(<ClaimDetail />)} />
      <Route path="/reports" element={<ProtectedRoute roles={["admin", "manager", "employee", "branch_manager"]}><AppLayout><Reports /></AppLayout></ProtectedRoute>} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
